// extracted by mini-css-extract-plugin
export default {"zoom":"gdvoUKiMiAvFd51QFKf1","zoomContainer":"XIY8BIamtMwR0CMIJPp3"};